module.exports = __webpack_public_path__ + "media/dpanthenol-medium.7e141292.mp4";